import { DynamoDBClient, GetItemCommand, PutItemCommand } from '@aws-sdk/client-dynamodb'
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb'
import {
  ANONYMOUS_TRACKING_PARAMS_TTL_SECONDS,
  type AnonymousTrackingParams,
  anonymousTrackingParamsSchema,
  pickPersistableTrackingParams,
} from './schema'

export class AnonymousTrackingParamsRepository {
  private client: DynamoDBClient
  private tableName = 'anonymous_tracking_params'

  constructor() {
    this.client = new DynamoDBClient({})
  }

  async upsert(anonymousId: string, params: Record<string, string>): Promise<void> {
    const trackingParams = pickPersistableTrackingParams(params)
    if (Object.keys(trackingParams).length === 0) {
      return
    }

    const expiresAt = Math.floor(Date.now() / 1000) + ANONYMOUS_TRACKING_PARAMS_TTL_SECONDS
    const command = new PutItemCommand({
      TableName: this.tableName,
      Item: marshall(
        {
          anonymous_id: anonymousId,
          expires_at: expiresAt,
          ...trackingParams,
        },
        { removeUndefinedValues: true }
      ),
    })

    await this.client.send(command)
  }

  async getByAnonymousId(anonymousId: string): Promise<AnonymousTrackingParams | null> {
    const command = new GetItemCommand({
      TableName: this.tableName,
      Key: marshall({ anonymous_id: anonymousId }),
    })
    const result = await this.client.send(command)
    if (!result.Item) {
      return null
    }

    const record = anonymousTrackingParamsSchema.parse(unmarshall(result.Item))
    if (record.expires_at <= Math.floor(Date.now() / 1000)) {
      return null
    }

    return record
  }
}
